import { useProductType } from "app/hooks/shared/standard-product/useProductType";
import StandardProductDescription from "entities/shared/standard-product/description";
import StandardProductPrice from "entities/shared/standard-product/price";
import StandardProductAmount, {
  StandardProductAmountType,
} from "features/shared/standard-product/amount";
import StandardProductAmountDropdown from "features/shared/standard-product/amount-dropdown";
import StandardProductControls from "features/shared/standard-product/controls";
import { CategoryStandardProduct } from "shared/api/middleware-api-client";
import { concatClassnames } from "shared/utils/concatClassnames";
import { MONTAGE_SERVICE_TYPE_CODE } from "../../../shared/utils/standard-product";

interface Props {
  standardProduct: CategoryStandardProduct;
  index: number;
  className?: string;
  setStandardProductAmount: (amount: number) => void;
}

const StandardProductItem = ({
  standardProduct,
  index,
  className,
  setStandardProductAmount,
}: Props) => {
  const type = useProductType(standardProduct);

  const isNotMontageServiceCategory =
    standardProduct.productType.code !== MONTAGE_SERVICE_TYPE_CODE &&
    standardProduct.productType.code !== "montageachtergrond";
  return (
    <div
      className={concatClassnames(
        className,
        "gg-grid gg-w-full gg-grid-cols-12 gg-justify-items-start gg-gap-4 gg-px-4 sm:gg-px-10 md:gg-px-16 lg:gg-px-0",
      )}
    >
      <div className="gg-col-span-12 lg:gg-col-span-7">
        <StandardProductDescription
          index={index}
          standardProduct={standardProduct}
        />
      </div>
      <div className="gg-order-last gg-col-span-12 gg-justify-self-center lg:gg-order-none lg:gg-col-span-2 lg:gg-col-start-8 lg:gg-justify-self-auto">
        {isNotMontageServiceCategory && (
          <StandardProductControls index={index} />
        )}
      </div>
      <div className="gg-col-span-12 gg-w-full lg:gg-col-span-full lg:gg-col-start-10">
        <div className="gg-grid gg-grid-cols-7 lg:gg-items-start lg:gg-gap-0">
          <div className="gg-col-span-1 gg-col-start-3 lg:gg-col-start-1">
            {type.isSet ? (
              <StandardProductAmountDropdown
                value={standardProduct.amount * 2}
                min={2}
                max={50}
                step={2}
                onChange={(value) =>
                  setStandardProductAmount(Number(value / 2))
                }
              />
            ) : (
              <StandardProductAmount
                type={StandardProductAmountType.BACKGROUND}
                amount={standardProduct.amount}
                setAmount={setStandardProductAmount}
                readOnly={
                  standardProduct.productType.code ===
                    MONTAGE_SERVICE_TYPE_CODE ||
                  standardProduct.productType.code === "montageachtergrond"
                }
              />
            )}
          </div>

          <div className="gg-col-span-full gg-col-start-5 gg-self-center gg-whitespace-normal gg-px-3 sm:gg-px-0">
            <StandardProductPrice standardProduct={standardProduct} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default StandardProductItem;
